import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { REGION_META } from "../XoSoCompound/constants";
import useXosoLive, { selectLiveResults } from "../XoSoCompound/useXosoLive";
import StationSelect from "./StationSelect";
import DateSelect from "./DateSelect";
import CompactResultTable from "./CompactResultTable";
import useStationResult from "./useStationResult";
import { resolveStation } from "./resolveStation";
import "./XoSoSidebar.css";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

function XoSoSidebar({ dataDefault, defaultStation, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [station, setStation] = useState(() =>
    resolveStation(dataDefault ?? defaultStation ?? config?.default)
  );
  const [date, setDate] = useState(today);
  const isToday = date === today;
  const { results, loading } = useStationResult(station, date);
  const live = useXosoLive(station, isToday);
  const usingLive = Boolean(isToday && live.results?.length);
  const displayResults = usingLive ? live.results : selectLiveResults(results, live);
  const meta = REGION_META[station];
  const liveDrawing = Boolean(usingLive && live.drawing);

  return (
    <div className="xoso-sidebar">
      <div className="xoso-sidebar__head">
        <div className="xoso-sidebar__title">
          KQXS <span>{meta.label}</span>
          {liveDrawing ? (
            <em className="xoso-sidebar__live">
              <span className="xoso-sidebar__live-dot" />
              Live
            </em>
          ) : null}
        </div>
        <StationSelect value={station} onChange={setStation} />
        <DateSelect value={date} onChange={setDate} maxDate={today} />
      </div>
      <CompactResultTable
        region={station}
        results={displayResults}
        date={date}
        loading={loading && !usingLive}
        liveDrawing={liveDrawing}
      />
    </div>
  );
}

XoSoSidebar.StationSelect = StationSelect;
XoSoSidebar.DateSelect = DateSelect;
XoSoSidebar.ResultTable = CompactResultTable;

export { StationSelect, DateSelect, CompactResultTable, resolveStation };
export default XoSoSidebar;
